import * as React from 'react';

import { isRenderingOnServer } from './isRenderingOnServer';

/**
 * Walks up the DOM from `node` and returns the nearest vertically scrollable
 * ancestor, or `null` when none is found.
 */
export const getScrollParent = (
  node: HTMLElement | null
): HTMLElement | null => {
  if (isRenderingOnServer()) {
    return null;
  }

  let current = node?.parentElement ?? null;

  while (current) {
    const { overflowY } = window.getComputedStyle(current);
    if (overflowY === 'auto' || overflowY === 'scroll') {
      return current;
    }
    current = current.parentElement;
  }

  return null;
};

/**
 * Whether a click on a link opens it in a new tab (Cmd/Ctrl/Shift or middle
 * click) or downloads it (Alt click) instead of navigating the current page.
 */
export const opensLinkInNewTab = (event: React.SyntheticEvent) => {
  const { metaKey, ctrlKey, shiftKey, altKey, button } =
    event.nativeEvent as MouseEvent;

  return metaKey || ctrlKey || shiftKey || altKey || button === 1;
};
